<template>
    <component :is="tag">
        <slot
            :proposalStep="step"
            :campaign="campaign"
            :contact="contact"
            :proposal="proposal"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-proposal-step="patchProposalStep"
            :is-loading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :is-patching-proposal="isPatchingProposal"
            :countries="countries"
            :provinces="provinces"
            :loading-countries="loadingCountries"
            :loading-provinces="loadingProvinces"
            :country-updated="countryUpdated"
            :errors="errors"
            :errorMessage="errorMessage"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin from "../mixins/BaseProposalStepMixin";
    import {NAME_SHIPPING_INFO} from '../../../constants/proposal-steps';

    export default {
        name: 'ShippingInfoProvider',
        mixins: [
            BaseProposalStepMixin,
        ],
        computed: {
            step() {
                return this.proposalSteps[NAME_SHIPPING_INFO]
            },
        },
        created() {
            this.isLoading = true;

            this.loadCountries()
                .then(() => this.loadContact()
                    .then(() => {
                        return Promise.all([
                            this.loadCampaign(),
                            this.loadProposal(),
                        ]);
                    })
                    .then(() => {
                        this.initProposalStep(this.step);
                    })
                    .catch(error => this.handleHttpError(error))
                    .then(() => {
                        this.isLoading = false;
                    })
                );
        }
    }
</script>
